// ==================================
// Alpinejs
// https://alpinejs.dev/
// ==================================
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()


// ==================================
// Homepage hero slider
// ==================================
let hhs = document.querySelector('.hero__container');
let hhsp = document.querySelector('.hero__dots');

function heroSlider() {
  let active_s = 1;
  let last_s = hhs.children.length;
  let delay = 7000

  hhs.querySelector(".hero__slide:nth-child(1)").classList.add("active");
  hhsp.querySelector(".hero__dot:nth-child(1)").classList.add("active");

  setInterval(function () {
    if (active_s == last_s) { active_s = 1; } else { active_s++; }

    hhs.querySelector(".active").classList.remove("active");
    hhs.querySelector(".hero__slide:nth-child(" + active_s + ")").classList.add("active");

    hhsp.querySelector(".active").classList.remove("active");
    hhsp.querySelector(".hero__dot:nth-child(" + active_s + ")").classList.add("active");

  }, delay);
}
if (hhs && hhsp) { heroSlider() }


// ==================================
// Siema slider
// https://github.com/pawelgrzybek/siema
// ==================================
import Siema from 'siema';

// Слайдеры экскурсий на главной
const esOptions = {
  duration: 500,
  easing: 'ease-out',
  perPage: {
    360: 1,
    680: 2,
    992: 3,
  },
  startIndex: 0,
  draggable: true,
  multipleDrag: true,
  threshold: 20,
  loop: true
}

const excursionsBlock = document.querySelector('.excursions__body');
if (excursionsBlock) {
  const esGroup = new Siema({
    selector: '.excursions_group', ...esOptions
  });
  window.esGroup = esGroup;

  const esIndividual = new Siema({
    selector: '.excursions_individual', ...esOptions
  });
  window.esIndividual = esIndividual;

  const repaint = (el) => { el.resizeHandler() }
  window.repaint = repaint;
}


// Слайдер товаров на главной
const productsOptions = {
  duration: 500,
  easing: 'ease-out',
  perPage: {
    360: 1,
    480: 2,
    768: 3,
    1200: 4,
  },
  startIndex: 0,
  draggable: true,
  multipleDrag: true,
  threshold: 20,
  loop: true
}

const productsBlock = document.querySelector('.products__block');
if (productsBlock) {
  const productsSlider = new Siema({
    selector: productsBlock, ...productsOptions
  });
  window.productsSlider = productsSlider;
}


// ==================================
// Datepicker
// https://mymth.github.io/vanillajs-datepicker
// ==================================
import { Datepicker } from 'vanillajs-datepicker';
const elem = document.querySelector('.select-date');
if (elem) {
  new Datepicker(elem);
}


// ==================================
// Smooth scroll to anchor
// ==================================
const gotop = document.querySelector('.gotop');
if (gotop) {
  gotop.addEventListener('click', (e) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  });
}


// ==================================
// Lightbox
// ==================================
import GLightbox from 'glightbox';
const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  slideEffect: 'fade',
});
